export const _LOAD_MODEL_ = 'Load:Material';
export const _SAVE_MATERIAL_SUCCESS_ = 'Save:MaterialSuccess';

export const MODEL = {
  id: null,
  name: null,
  price: null,
  unit_type_id: null,
  unit_type: {
    id: null,
    name: null,
    description: null,
  },
};
